// components/branding/Titles.tsx

import { isNommi } from '@/utils/brand';
import { UserCircleIcon, BanknotesIcon, ReceiptPercentIcon } from '@heroicons/react/24/outline';

type Props = {
    title?: string;
    color?: string;
    count?: number;
};

export function ContactTitle({ title = 'Seus dados', color = '#000' }: Props) {
    if (isNommi) {
        return (
            <div className="my-6 font-bold">
                <span style={{ color }} className="text-lg">
                    Informação de contato
                </span>
            </div>
        );
    }

    return (
        <div className="flex items-center my-6 font-bold">
            <UserCircleIcon style={{ color }} width={24} height={24} className="mr-2" />
            <span style={{ color }} className="text-lg">{title}</span>
        </div>
    );
}

export function PaymentTitle({ title = 'Pagamento', color = '#000' }: Props) {
    if (isNommi && title === 'Pagamento') {
        return (
            <div className="my-4 font-bold">
                <span style={{ color }} className="text-lg">
                    Métodos de Pagamento
                </span>
            </div>
        );
    }

    return (
        <div className="flex items-center mb-4 font-bold">
            <BanknotesIcon style={{ color }} width={24} height={24} className="mr-2" />
            <span style={{ color }} className="text-lg">{title}</span>
        </div>
    );
}

export function BumpOfferTitle({ color, count = 0 }: Props) {
    return (
        <div className={`mt-6 mb-4 font-bold ${!isNommi ? 'flex items-center' : ''}`}>
            {!isNommi && (
                <ReceiptPercentIcon
                    style={{ color }}
                    width={24}
                    height={24}
                    className="mr-2"
                />
            )}
            <span style={{ color }} className="text-lg">
                {isNommi
                    ? 'Adicione também no seu pedido:'
                    : count > 1
                        ? 'Ofertas limitadas'
                        : 'Oferta limitada'}
            </span>
        </div>
    );
}
